const TYPES = "HIMALAYAS_IO_SIM";

export const OPEN_IO_SIM_PAGE = `${TYPES}/open_io_sim_page`;
export const UPDATE_IO_SIM_INFO = `${TYPES}/update_io_sim_info`;
export const CLEAR_IO_SIM_INFO = `${TYPES}/clear_io_sim_info`;
export const SAVE_SIM_OPTIONS = `${TYPES}/save_simulation_options`